import { AfterViewInit, Component, Input } from '@angular/core';
import { MaskedDateCellEditorBaseComponent } from '../masked-date-cell-editor-base/masked-date-cell-editor-base.component';


@Component({
    selector: 'se-masked-date-cell-editor-popup',
    templateUrl: './masked-date-cell-editor-popup.component.html',
    styleUrls: ['./masked-date-cell-editor-popup.component.scss']
})


export class MaskedDateCellEditorPopupComponent extends MaskedDateCellEditorBaseComponent implements AfterViewInit {

    @Input() width: string;

    ngAfterViewInit(): void {
        this.formReady.emit(this.formControl);
        window.setTimeout(() => {
            this.dateInput.nativeElement.focus();
            this.dateInput.nativeElement.select();
        }, 0);
    }
}
